export const DEFAULT_BUSINESS_TIMEZONE = 'America/New_York';

export const TIMEZONES = [
  DEFAULT_BUSINESS_TIMEZONE,
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Indiana/Indianapolis',
] as const;
